import { gql } from "@apollo/client";

export const FREE_UPGRADE_WINNERS = gql`
query FreeUpgradeWinner($first: Int!, $skip: Int!) {
  freeUpgradeWinner(first: $first, skip: $skip) {
    prefix
    firstName
    lastName
    pnr
    flightDate
    route {
      contentItems {
        __typename
        ... on Route {
          availableForAgency
          code {
            code
          }
        }
      }
    }
  }
}
`